jQuery(document).ready(function($) {
  $('.announcement-bar-inner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  });

  $(window).scroll(function(e) {
    if ( $(window).scrollTop() > 40 ) {
      $('header.site-header').addClass('scrolled');
    } else {
      $('header.site-header').removeClass('scrolled');
    }
  });

  $('.product-swatch-list .swatch:not(.disabled)').on('click', function() {
    var $this = $(this),
        value = $this.data('value'),
        selection = $this.parents('.variant-selection').find('.single-option-selector');
    
    $this.parent().find('.swatch').removeClass('selected');
    $this.addClass('selected');
    selection.val(value).trigger('change');
  });

  $('#product-description .rte p:last-child a, a[href="#sizing"]').on('click', function(e) {
    e.preventDefault();

    $('.product-size-chart-popup').addClass('shown');
  });

  $('.product-size-chart-popup').on('click', function(e) {
    if ( ! $(e.target).is('.product-size-chart-popup-inner, .product-size-chart-popup-inner *') ) {
      $('.product-size-chart-popup').removeClass('shown');  
    }
  });

  $('.product-size-chart-popup-inner .close').on('click', function() {
    $('.product-size-chart-popup').removeClass('shown');
  });

  var initialMobileHeader = () => {
    if ( $(window).width() < 1024 ) {
      $('header.site-header').addClass('mobile-header');
    } else {
      $('header.site-header').removeClass('mobile-header');
    }
  }

  initialMobileHeader();
  $(window).resize(function() {
    initialMobileHeader();
  });

  $('.mobile-header .site-main-nav .dlinks').on('click', function(e) {
    var $this = $(this);

    // if ( $(e.target).is('.nav-down, .nav-down *') ) {
    // }
    e.preventDefault();
    $this.next('.submenu').slideToggle();
  });

  $('header.site-header .mobile-burger-menu').on('click', function() {
    $('header.site-header .site-nav-wrap').toggleClass('shown');
  });

  $('.site-nav-wrap .mobile-nav-head .close').on('click', function() {
    $('header.site-header .site-nav-wrap').removeClass('shown');
  });

  $('.product-mobile-slide-inner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg aria-hidden="true" focusable="false" fill="none" width="20" viewBox="0 0 10 10"><path d="M7 1 3 5l4 4" stroke="#333" stroke-linecap="square"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg aria-hidden="true" focusable="false" fill="none" width="20" viewBox="0 0 10 10"><path d="m3 9 4-4-4-4" stroke="#333" stroke-linecap="square"/></svg></button>',
  });

  const onHistoryChange = (event) => {
    console.log(event)
  }
  window.addEventListener('popstate', onHistoryChange);

  $(window).on("load", function () {
    setTimeout(function () {
      $('.site-footer__accessbi-item').show();
    }, 3000);
});
});
